module.exports = __webpack_public_path__ + "img/404.f78cd09c.png";